export const usersEndpointIds = {
    GET_BETA_TESTER_STATUS: 'GET_BETA_TESTER_STATUS',
    TRANSFORM_TO_CREATOR: 'TRANSFORM_TO_CREATOR',
    GET_APPLICATION_STATE: 'GET_APPLICATION_STATE',
    HIDE_ENGAGE_VIEWERS_MESSAGE: 'HIDE_ENGAGE_VIEWERS_MESSAGE',
};
